import { PublicProfile } from "@dimensional-engineering/dimensional-models";
import PublicFooter from "../../publicProfiles/Footer/PublicFooter";
import TraitsFooter from "../../traits/shared/TraitsFooter/TraitsFooter";
import styles from "./Footers.module.css";

type FootersProps = {
  connectionList?: PublicProfile[];
};

export default function Footers(props: FootersProps) {
  return (
    <div className={styles.main}>
      {/* {props.connectionList?.map((l) => {
        return <p key={l.name}>{l.name}</p>;
      })} */}
      <TraitsFooter connectionList={props.connectionList} />
      <PublicFooter />
    </div>
  );
}
